import Vue from "vue";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["Account", "App", "CookieToast", "Contact", "JobOffer", "Store"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                this.$store.dispatch("cartStore/getCart");

                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setNavigation();
        this.setBackgroundColor();
        this.setCtaFooter();
        this.setAnimation();
        this.openInfoRequest();
        this.setAnalytics();
    }

    private static setAnalytics() {
        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }

        document.getElementById("GaEventPhone")?.addEventListener("click", function () {
            GTagHelper.sendEvent("click", "phone", "footer");
        });

    }

    private static setAnimation() {
        gsap.config({ nullTargetWarn: false })
        gsap.registerPlugin(ScrollTrigger);

        var gradientSroll = document.getElementsByClassName("gradient-sroll"),
            slide = document.getElementsByClassName("slide"),
            imagePan = document.getElementsByClassName("image-pan"),
            lightTl = document.getElementsByClassName("light-tl"),
            lightTr = document.getElementsByClassName("light-tr"),
            lightBr = document.getElementsByClassName("light-br"),
            lightBt = document.getElementsByClassName("light-bt");

        if (gradientSroll) {
            for (var i = 0; i < gradientSroll.length; i++) {
                gsap.to(gradientSroll[i], {
                    backgroundPositionY: "100%",
                    scrollTrigger: {
                        trigger: gradientSroll[i],
                        start: "top 100%",
                        end: "bottom 60%",
                        scrub: true,
                    }
                });
            }
        }

        if (slide) {
            for (var i = 0; i < slide.length; i++) {
                gsap.to(slide[i], {
                    transform: "translateX(0)",
                    opacity: 1,
                    scrollTrigger: {
                        trigger: slide[i],
                        start: "top 100%",
                        end: "bottom 60%",
                        scrub: true,
                    }
                });
            }
        }

        if (imagePan) {
            for (var i = 0; i < imagePan.length; i++) {
                gsap.to(imagePan[i], {
                    transform: "translate(0, -200px)",
                    opacity: 1,
                    scrollTrigger: {
                        trigger: imagePan[i],
                        start: "bottom 100%",
                        end: "top -20%",
                        scrub: true,
                    }
                });
            }
        }

        if (lightTl) {
            for (var i = 0; i < lightTl.length; i++) {
                gsap.to(lightTl[i], {
                    left: "80%",
                    opacity: 0,
                    scrollTrigger: {
                        trigger: lightTl[i],
                        start: "bottom 100%",
                        end: "top -50%",
                        scrub: true,
                    }
                });
            }
        }

        if (lightTr) {
            for (var i = 0; i < lightTr.length; i++) {
                gsap.to(lightTr[i], {
                    right: "80%",
                    opacity: 0,
                    scrollTrigger: {
                        trigger: lightTr[i],
                        start: "bottom 100%",
                        end: "top -50%",
                        scrub: true,
                    }
                });
            }
        }

        if (lightBr) {
            for (var i = 0; i < lightBr.length; i++) {
                gsap.to(lightBr[i], {
                    right: "80%",
                    opacity: 0,
                    scrollTrigger: {
                        trigger: lightBr[i],
                        start: "bottom 100%",
                        end: "top -50%",
                        scrub: true,
                    }
                });
            }
        }

        if (lightBt) {
            for (var i = 0; i < lightBt.length; i++) {
                gsap.to(lightBt[i], {
                    bottom: "95%",
                    opacity: 0,
                    scrollTrigger: {
                        trigger: lightBt[i],
                        start: "bottom 100%",
                        end: "top -50%",
                        scrub: true,
                    }
                });
            }
        }
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setNavigation() {
        let app = document.getElementById("body"),
            header = document.getElementById("Header"),
            main = document.getElementById("main"),
            tools = document.getElementById("Tools"),
            wrapMenuSupportLink = document.querySelectorAll(".button[data-service]");

        for (const wrapMenuLink of wrapMenuSupportLink) {
            wrapMenuLink.addEventListener("click", e => {
                let dataType = <HTMLElement>e.target;
                let parentElement = dataType.parentElement;
                document.querySelectorAll(".item[data-type]").forEach(doc => doc.classList.remove("active"));
                document.querySelector(".item[data-type=" + parentElement.dataset.type + "]").classList.add("active");
                app.classList.add("overflow");
                header.classList.add("service-show");
                main.classList.add("service-show");
                tools.classList.add("hdn");
            });
        }

        let serviceClose = document.querySelectorAll(".button[data-close]");
        if (serviceClose && serviceClose.length != 0) {
            for (let i = 0; i < serviceClose.length; i++) {
                serviceClose[i].addEventListener("click", function () {
                    document.querySelectorAll(".item[data-type]").forEach(doc => doc.classList.remove("active"));
                    app.classList.remove("overflow");
                    header.classList.remove("service-show");
                    main.classList.remove("service-show");
                    tools.classList.remove("hdn");
                    header.classList.remove("mobile-menu-show");
                });
            }
        }

        if (header) {
            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-minify", "");
                    header.setAttribute("data-hide", "");
                    document.querySelectorAll(".app-header .action-menu").forEach(doc => doc.classList.remove("show"));
                } else {
                    header.removeAttribute("data-minify");
                    header.removeAttribute("data-hide");
                    document.querySelectorAll(".app-header .action-menu").forEach(doc => doc.classList.remove("show"));
                }
            });

            let posizioneScroll = window.pageYOffset;

            window.addEventListener("scroll", function () {
                if (window.pageYOffset < posizioneScroll) {
                    header.removeAttribute("data-hide");
                    document.querySelectorAll(".app-header .action-menu").forEach(doc => doc.classList.remove("show"));
                }
                posizioneScroll = window.pageYOffset;
            });
        }

        let mobileMenuButton = document.getElementById("MobileMenuButton");
        if (mobileMenuButton) {
            mobileMenuButton.addEventListener("click", function () {
                header.classList.add("mobile-menu-show");
                app.classList.add("overflow");
            });
        }

        let mobileMenuBack = document.querySelectorAll(".button[data-back]");
        if (mobileMenuBack && mobileMenuBack.length != 0) {
            for (let i = 0; i < mobileMenuBack.length; i++) {
                mobileMenuBack[i].addEventListener("click", function () {
                    document.querySelectorAll(".item[data-type]").forEach(doc => doc.classList.remove("active"));
                    header.classList.remove("service-show");
                    main.classList.remove("service-show");
                    tools.classList.remove("hdn");
                });
            }
        }
    }

    private static setBackgroundColor() {
        window.addEventListener("scroll", (event) => {
            let panel = document.querySelectorAll(".layout"),
                header = document.getElementById("Header"),
                footer = document.getElementById("Footer"),
                scroll = window.scrollY + (window.screen.height / 4);

            for (var i = 0; i < panel.length; i++) {
                let thisPanel = panel[i];

                if ((<HTMLElement>thisPanel).offsetTop <= scroll && (<HTMLElement>thisPanel).offsetTop + (<HTMLElement>thisPanel).offsetHeight > scroll) {
                    document.body.className = "";
                    document.body.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
                    header.className = "";
                    header.classList.add("app-header");
                    header.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
                    footer.className = "";
                    footer.classList.add("app-footer");
                    footer.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
                }
            };
        });
    }

    private static setCtaFooter() {
        let wrapper
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

        async function writingAll(stringTarget, container) {
            wrapper = document.querySelector('[' + container + ']')
            const stringsContainer = document.getElementsByClassName(stringTarget)

            while (wrapper) {
                for (let i = 0; i < stringsContainer.length; i++) {
                    const string = stringsContainer[i].textContent
                    await write(string)
                    await sleep(1000)
                    await erase()
                    await sleep(300)
                };
            }
        };

        async function write(text) {
            let index = 0
            while (index < text.length) {
                const timeout = 50
                await sleep(timeout)
                index++
                wrapper.innerHTML = text.substring(0, index)
            }
        };


        async function erase() {
            while (wrapper.textContent.length) {
                const timeout = 50
                await sleep(timeout)
                wrapper.textContent = wrapper.textContent.substring(0, wrapper.textContent.length - 2)
            }
        };

        writingAll("message", "data-text");
    }

    private static openInfoRequest() {
        let buttons = document.querySelectorAll(".is-info-request");
        for (const item of buttons) {
            item.addEventListener("click", x => {
                GTagHelper.sendEvent("click", "info_request", "website");
                (<any>window).App.instances.vm.$store.commit("infoRequestStore/setInfoRequestVisible", true);
            })
        }
    }
}